export class CertificacionPn {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            fecha: {
                value: null,
                header: 'Fecha',
            },
            apellidos: {
                value: '',
                header: 'Apellidos:',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Campo requerido'
            },
            nombres: {
                value: '',
                header: 'Nombres:',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Campo requerido'
            },
            tipo_identificacion: {
                value: null,
                header: 'Tipo de identificación:',
                required: 'Seleccione alguna opción'
            },
            identificacion: {
                value: '',
                header: 'Número de identificación:',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
                required: 'Campo requerido'
            },
            fecha_nacimiento: {
                value: null,
                header: 'Fecha de nacimiento:',
                required: 'Campo requerido'
            },
            direccion_residencia: {
                value: '',
                header: 'Dirección permanente de residencia (calle, número, piso, departamento, referencia de ubicación):',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 500,
                min: 4,
                required: 'Campo requerido'
            },
            pais_nacimiento: {
                value: null,
                header: 'País de nacimiento:',
                required: 'Seleccione alguna opción'
            },
            provincia_nacimiento: {
                value: null,
                header: 'Provincia de nacimiento:',
                required: 'Seleccione alguna opción'
            },
            ciudad_nacimiento: {
                value: null,
                header: 'Ciudad de nacimiento:',
                required: 'Seleccione alguna opción'
            },
            canton_nacimiento: {
                value: '',
                header: 'Ciudad de nacimiento:',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
                required: 'Campo requerido'
            },
            pais: {
                value: null,
                header: 'País:',
                required: 'Seleccione alguna opción'
            },
            provincia: {
                value: null,
                header: 'Provincia:',
                required: 'Seleccione alguna opción'
            },
            ciudad: {
                value: null,
                header: 'Ciudad:',
                required: 'Seleccione alguna opción'
            },
            canton: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
                required: 'Campo requerido'
            },
            codigo_postal: {
                value: '',
                header: 'Código postal:',
                maxLength: 'Máximo 20 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 20,
                min: 4,
                required: 'Campo requerido'
            },
            eeuu_fin_fiscal: {
                value: null,
                header: '¿Es ciudadano o residente de los Estados Unidos para fines fiscales?',
                required: 'Seleccione alguna opción'
            },
            eeuu_identificacion: {
                value: '',
                header: 'Número de identificación fiscal de los Estados Unidos (TIN):',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
                required: 'Campo requerido'
            },
            extranjero_fin_fiscal: {
                value: null,
                header: '¿Es ciudadano o residente de otro país para fines fiscales?',
                required: 'Seleccione alguna opción'
            },
        }
    }
    strAuto = <><p>Conforme a las regulaciones del Estándar Común de Reporte (CRS por sus siglas en inglés) en el marco de la OCDE (Organización para la Cooperación
        y Desarrollo Económico), lo establecido en la Disposición General Primera de la Ley Orgánica para la Reactivación de la Economía, Fortalecimiento de la Dolarización
        y Modernización de la Gestión, publicada en el Suplemento del Registro Oficial No. 150 de 29 de diciembre de 2017 y según lo señalado en la Resolución
        NAC-DGERCGC19-00000003 del Servicio de Rentas Internas, publicada en el Suplemento del Registro Oficial No. 428 de 14 de febrero de 2019, se ha dispuesto la
        obligación de reportar información específica sobre la residencia fiscal de una cuenta.</p>
        <p>Con el objeto de dar cumplimiento con la normativa expuesta, se ha implementado el presente formulario de auto-certificación a fin de que los datos registrados en
            el mismo, sean transmitidos al Servicio de Rentas Internas que a su vez podrá enviar esta información a las autoridades fiscales de otras jurisdicciones en
            virtud de acuerdos intergubernamentales para intercambiar información de cuentas financieras.</p>
        <b>Por favor lea estas instrucciones antes de llenar el formulario.-<br /><br />¿Quién debe llenar este formulario?</b>
    </>
    strNormal = <><p>La persona natural que sea titular de una o varias cuentas.</p>
        <p>En caso de poseer cuentas conjuntas o a nombre de varias personas, cada titular debe firmar este Formulario de Auto-certificación.</p>
        <p>No llene este formulario si usted representa a una sociedad o empresa, en su lugar, debe presentar un Formulario de Auto-certificación de Residencia Fiscal para SOCIEDADES</p>
        <p>Puede encontrar más información, incluida una lista de jurisdicciones que han firmado acuerdo para intercambiar información automáticamente, junto con los detalles de la
            información solicitada en el portal de la OECD en la sección “Automatic Exchange of Information”:
            <a target="blank" href="http://www.oecd.org/tax/automatic-exchange/">http://www.oecd.org/tax/automatic-exchange/</a>.</p></>
    strControl = <><p>El Constituyente / Beneficiario de un Fideicomiso que sea una Entidad No Financiera (ENF) Pasiva o una Entidad de Inversión residentes en el exterior
        y administrada por otra Institución Financiera.</p>
        <p>No llene este formulario si representa a una sociedad distinta a una Entidad No Financiera (ENF) Pasiva o una Entidad de Inversión, en su lugar, debe presentar un
            Formulario de Auto-certificación de Residencia Fiscal para SOCIEDADES.</p>
        <p>Use un formulario separado para cada persona que ejerce el control.</p>
        <p>Si requiere informar sobre sus Fideicomisos personales, llene y envíe un formulario de Auto-certificación de Residencia Fiscal para PERSONAS NATURALES.</p>
        <p>Si representa a una sociedad distinta a una Entidad No Financiera (ENF) Pasiva o una Entidad de Inversión, no llene este formulario, llene y envíe un
            formulario de Auto-certificación de Residencia Fiscal para SOCIEDADES.</p>
        <p>Puede encontrar más información, incluida una lista de jurisdicciones que han firmado acuerdo para intercambiar información automáticamente, junto con los detalles de la
            información solicitada en el portal de la OECD en la sección “Automatic Exchange of Information”:
            <a target="blank" href="http://www.oecd.org/tax/automatic-exchange/">http://www.oecd.org/tax/automatic-exchange/</a>.</p></>
    strCertificacion = (nombreSujeto = '') => <><p>Por este medio certifico que la información proporcionada en este formulario es correcta y completa.</p><ul>
        <li>Autorizo a <b>{nombreSujeto}</b> a proporcionar, directa o indirectamente, la información
            contenida en este formulario y/o una copia de este formulario a cualquier autoridad fiscal pertinente o cualquier parte autorizada
            para auditar o realizar un control similar de <b>{nombreSujeto}</b> para fines fiscales, así como
            a divulgar a tales autoridades fiscales o tal parte cualquier información adicional que pudiese poseer <b>{nombreSujeto}</b>
            y que es pertinente para mi calificación para cualquier beneficio reclamado con base en esta certificación.</li>
        <li>Acepto que la información contenida en este formulario y la información relacionada con mis cuentas en <b>{nombreSujeto}</b> (incluso la información sobre los
            saldos de cuentas y pagos recibidos) se notifique a las autoridades fiscales pertinentes, y que estas autoridades proporcionen esta información a cualquier otro
            país enumerado en la lista anterior como a un país en el cual soy residente para fines fiscales.</li>
        <li>Me comprometo a avisar inmediatamente a <b>{nombreSujeto}</b> sobre cualquier cambio en las circunstancias que motive que la información contenida
            en este documento sea incorrecta y a proporcionar a <b>{nombreSujeto}</b> un formulario actualizado y apropiado de Auto-certificación de Residencia Fiscal en un
            plazo de 30 días a partir de la fecha del cambio en las circunstancias.</li></ul></>
    strCerControl = <><p>Por este medio certifico que la información proporcionada en este formulario es correcta y completa.</p>
        <p>Autorizo a Trust Fiduciaria Administradora de Fondos y Fideicomisos S.A. a proporcionar, directa o indirectamente, la información contenida en este formulario y/o una
            copia de este formulario a cualquier autoridad fiscal pertinente o cualquier parte autorizada para auditar o realizar un control similar de Trust Fiduciaria Administradora
            de Fondos y Fideicomisos S.A para fines fiscales, así como a divulgar a tales autoridades fiscales o tal parte cualquier información adicional que pudiese poseer Trust
            Fiduciaria Administradora de Fondos y Fideicomisos S.A. y que es pertinente para mi calificación para cualquier beneficio reclamado con base en esta certificación.</p>
        <p>Acepto que la información contenida en este formulario y la información relacionada con mis fideicomisos en Trust Fiduciaria Administradora de Fondos y Fideicomisos S.A.
            (incluso la información sobre los saldos de cuentas y pagos recibidos) se notifique a las autoridades fiscales pertinentes, y que estas autoridades proporcionen esta
            información a cualquier otro país enumerado en la lista anterior como a un país en el cual soy residente para fines fiscales.</p></>
    tituloNormal = <>AUTO-CERTIFICACIÓN DE RESIDENCIA FISCAL PARA PERSONAS NATURALES</>
    tituloControl = <>FORMULARIO AUTO-CERTIFICACIÓN DE RESIDENCIA FISCAL PARA PERSONAS QUE EJERCEN EL CONTROL</>
}
